<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "hashrate"
    }
</script>

<style scoped>

</style>